import { IFilter } from '../../types/advancedFilters';
import { BalconyContainer } from '../../containers/advancedFilters/BalconyContainer';

export const balcony: IFilter = {
  component: BalconyContainer,
};
